import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

interface QCQuickCheckDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  routingStepId: string;
}

export default function QCQuickCheckDialog({
  open,
  onOpenChange,
  routingStepId,
}: QCQuickCheckDialogProps) {
  const [measurement, setMeasurement] = React.useState("");

  const handleSubmit = () => {
    toast.success("Đã ghi nhận thông số QC!");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Kiểm tra Chất lượng (QC Nháp)</DialogTitle>
          <DialogDescription>
            Nhập nhanh các thông số đo kiểm định kỳ tại máy.
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-[minmax(0,1fr)] gap-4 py-4">
          <div className="grid grid-cols-[minmax(0,1fr)] gap-2">
            <Label htmlFor="measurement">Kích thước / Trọng lượng thực tế</Label>
            <Input
              id="measurement"
              placeholder="VD: 10.5 mm"
              value={measurement}
              onChange={(e) => setMeasurement(e.target.value)}
            />
          </div>
        </div>

        <DialogFooter className="sm:justify-between">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Hủy
          </Button>
          <Button className="bg-indigo-600 hover:bg-indigo-700" onClick={handleSubmit}>
            Lưu Kết Quả
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
